import {closePermissionModal} from './helpers';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import React from 'react';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import {nativeApi} from './NativeAPI';
import { useNavigate, useLocation } from 'react-router-dom';

export const SlideUp = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const PermissionModal = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    // Use URLSearchParams instead of Node.js querystring
    const searchParams = new URLSearchParams(location.search);
    const permission = searchParams.get('permission');
    
    return (
        <Dialog
            open={!!permission}
            onClose={()=>closePermissionModal(navigate)}
            TransitionComponent={SlideUp}
            keepMounted
            maxWidth={'md'}
            PaperProps={{ style: { margin: '24px' } }}
            fullWidth
        >
            <DialogTitle>Missing Permissions</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    Hey there! We are missing the following permissions:
                </DialogContentText>
                <DialogContentText>
                    <b>{permission}</b>
                </DialogContentText>
                <DialogContentText>Please go to your app settings and enable them!</DialogContentText>
                <DialogActions>
                    <Button variant={'text'} onClick={()=>closePermissionModal(navigate)} color="secondary">
                        dismiss
                    </Button>
                    <Button
                        variant={'contained'}
                        onClick={() => {
                            closePermissionModal(navigate);
                            nativeApi.openAppSettings();
                        }}
                        color="secondary"
                    >
                        Go to settings
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>)
};
